import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const HousingIndustryHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/f7578f3c3520b415cd67c14115e51c80_IS24_HousingIndustry_highlighter.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/c179de6ab21e8e0d81c1c27bd9a5e485_IS24_HousingIndustry_highlighter@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/6a4f952521f63e6f6ede37f6f1a580fc_IS24_HousingIndustry_highlighter@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/f7578f3c3520b415cd67c14115e51c80_IS24_HousingIndustry_highlighter.png'
        }
        width={90}
        height={87}
        alt={''}
      />
    </div>
  )
}
